// extracted by mini-css-extract-plugin
module.exports = {"title":"title__gfxtJ","form":"form__1i4KO","textarea":"textarea__nl8jI","modal":"modal__1bbi1"};